const initialState = {
  isOpen: false,
  params: {},
}

export default function dialog(state = initialState, action) {
  switch (action.type) {
    case 'OPEN_DIALOG':
      return {
        ...state,
        isOpen: true,
        params: action.payload,
      }
    case 'CLOSE_DIALOG':
      return {
        ...state,
        isOpen: false,
        params: {},
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dialog.js